import ComponentProgress from '../api/componentProgress';
import { applicationUpdate, applicationApiExecute } from './applicationActions';

export const startComponentProgress = applicationApiExecute(ComponentProgress.start);
export const updateComponentProgress = applicationUpdate(ComponentProgress);
